import ApiService from '../apiservice'

export default class PedidoProcessoService extends ApiService {
  constructor() {
    super('/pedidoProcesso');
  }

  cadastrarPedidoProcesso(pedido) {
    return this.post('/',pedido);
  }

  consultarPedidosProcesso(processo) {
    return this.get(`/pedidosPorProcesso/${processo}`);
  }

  consultarPedidoProcesso(codigo) {
    return this.get(`/${codigo}`);
  }

  alterarPedidoProcesso(pedido) {
    return this.put(`/${pedido.codigo}`, pedido);
  }

  excluirPedido(codigo) {
    return this.delete(`/${codigo}`);
  }
}